<div class="row px-4 py-8">
  <div class="col-lg-12">
    <mat-card class="cardWithShadow theme-card">
      <mat-card-header>
        <mat-card-title class="m-b-0"> Alterar senha </mat-card-title>
      </mat-card-header>
      <mat-card-content class="b-t-1"> 
        <form [formGroup]="form">
          <div class="row pb-2">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16"
                >Senha atual*</mat-label
              >
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100">
                <input
                  formControlName="senhaAtual"
                  matInput
                  placeholder="senha atual"
                  [type]="tipoInputSenha"
                />
                <button matSuffix mat-icon-button type="button"  (click)="mostrarEsconderSenha()">
                  <mat-icon *ngIf="tipoInputSenha === 'password'" class="op-5" fontSet="material-icons-outlined">visibility</mat-icon>
                  <mat-icon *ngIf="tipoInputSenha === 'text'" class="op-5" fontSet="material-icons-outlined">visibility_off</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    form.controls['senhaAtual'].hasError('required') &&
                    form.controls['senhaAtual'].touched
                  "
                  >campo obrigatório</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="row p-b-8 p-b-8">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16"
                >Senha*</mat-label
              >
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100">
                <input
                  formControlName="senha"
                  matInput
                  [type]="tipoInputNovaSenha"
                  placeholder="Senha"
                />
                <button matSuffix mat-icon-button type="button"  (click)="mostrarEsconderNovaSenha()">
                  <mat-icon *ngIf="tipoInputNovaSenha === 'password'" class="op-5" fontSet="material-icons-outlined">visibility</mat-icon>
                  <mat-icon *ngIf="tipoInputNovaSenha === 'text'" class="op-5" fontSet="material-icons-outlined">visibility_off</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    form.controls['senha'].hasError('required') &&
                    form.controls['senha'].touched
                  "
                  >campo obrigatório</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="row p-b-8 p-b-8">
            <div class="col-sm-12 d-flex align-items-center">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-16"
                >Confirme a senha*</mat-label
              >
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="w-100">
                <input
                  formControlName="resenha"
                  matInput
                  [type]="tipoInputResenha"
                  placeholder="Confirma a senha"
                />
                <button matSuffix mat-icon-button type="button"  (click)="mostrarEsconderResenha()">
                  <mat-icon *ngIf="tipoInputResenha === 'password'" class="op-5" fontSet="material-icons-outlined">visibility</mat-icon>
                  <mat-icon *ngIf="tipoInputResenha === 'text'" class="op-5" fontSet="material-icons-outlined">visibility_off</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    form.controls['resenha'].hasError('required') &&
                    form.controls['resenha'].touched
                  "
                  >campo obrigatório</mat-error
                >
                <mat-error
                  *ngIf="
                    form.controls['resenha'].hasError('diferente') &&
                    form.controls['resenha'].touched
                  "
                  >senhas diferentes</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <div class="w-100 flex flex-col items-center justify-center gap-8">
            <a
              (click)="alterarSenha()"
              mat-flat-button
              color="primary"
              class="w-100"
              [disabled]="!form.valid"
            >
              Atualizar
            </a>
            <a
              (click)="cancelarDialogo()"
              mat-flat-button
              class="w-100"
            >
              Cancelar
            </a>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
